import styled from "@emotion/styled";
import noAccess from "../../../assets/noAccess.png";

const AccessDeniedWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; // Match parent height
  width: 100%; // Match parent width
  background-color: #f4f4f4;
  background-image: url(${noAccess});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain; // Adjust image size
  text-align: center;
  padding: 50px; // Space around content
  box-sizing: border-box;
`;

const SC = {
  AccessDeniedWrapper,
};

export default SC;
